/*
* JS File for INMAGAZIN Stuttgart
 */


document.addEventListener('DOMContentLoaded', function () {

    function setupToggle(collapseId, buttonId, moreText, lessText) {
        const collapse = document.getElementById(collapseId);
        const button = document.getElementById(buttonId);

        if (!collapse || !button) return;

        collapse.addEventListener('shown.bs.collapse', function () {
            button.textContent = lessText;
        });

        collapse.addEventListener('hidden.bs.collapse', function () {
            button.textContent = moreText;
        });
    }

    setupToggle(
        'more-articles',
        'toggle-articles-button',
        'Mehr Artikel anzeigen',
        'Weniger Artikel anzeigen'
    );

    setupToggle(
        'more-shorts',
        'toggle-shorts-button',
        'Mehr Kurzmeldungen anzeigen',
        'Weniger Kurzmeldungen anzeigen'
    );
});